'use client';

import Script from 'next/script';

import { getENV } from '../../utils/env';

export const OptimizelyLegacy = () => {
    const projectID = getENV('NEXT_PUBLIC_OPTIMIZELY_PROJECT_ID');

    return <Script id="optimizely-script" src={`https://cdn.optimizely.com/js/${projectID}.js`} />;
};
